import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import { initCarousel } from "../../objects/carousel";
import { responsiveMediaAbove } from '../../settings/responsive';
var SEL_CONTAINER = '[data-product-single-container]';
var SEL_CAROUSEL = '[data-carousel]';
document.querySelectorAll(SEL_CONTAINER).forEach(function (container) {
  var carousel = container.querySelector(SEL_CAROUSEL);
  if (!carousel) return;
  var carouselInitialised = initCarousel(carousel, {
    loop: false,
    slidesPerView: 1,
    spacing: 0
  });

  var onResize = function onResize() {
    if (!carouselInitialised) return;

    if (responsiveMediaAbove('MEDIUM')) {
      var _carousel = carouselInitialised.slider;

      _carousel.destroy();
    } else {
      var _carousel2 = carouselInitialised.slider;

      _carousel2.refresh();
    }
  };

  window.addEventListener('resize', onResize);
  window.addEventListener('load', onResize);
});